import React from 'react'
import {
  CookieBanner as StylistCookieBanner,
  DefaultCookiePolicy,
} from 'stylist'

const CookieBanner = ({ onAccept, highlighted }) => (
  <React.Fragment> 
    <StylistCookieBanner onAccept={onAccept} highlighted={highlighted}>
      <DefaultCookiePolicy />
    </StylistCookieBanner>
  </React.Fragment>
)

export default CookieBanner



// WEBPACK FOOTER //
// ./src/components/CookieAcceptance/CookieBanner.js